import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'bevvi-user-chat-bubble',
  imports: [NgStyle],
  templateUrl: './user-chat-bubble.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserChatBubble {
  public readonly message = input.required<string>();
  public readonly backgroundColor = input('var(--bot-bubble-bg, #E6B2A3)');
  public readonly textColor = input('#000000');

  protected readonly bubbleStyles = computed(() => ({
    '--bubble-bg': this.backgroundColor(),
    '--bubble-text': this.textColor(),
  }));
}
